import { Redirect, Route, Switch } from 'react-router-dom';

import { TaggingAppDispatcher } from './pages/Homepage';
import NotFound from './pages/NotFound/NotFound';

export const DefaultRoutes = {
  FrontPage: '/Homepage',
} as const;

export const routes = (
  <Switch>
    <Route exact path='/'>
      <Redirect to={DefaultRoutes.FrontPage} />
    </Route>
    <Route exact path={DefaultRoutes.FrontPage} component={TaggingAppDispatcher} />
    <Route component={NotFound} />
  </Switch>
);
